export default "__VITE_ASSET__dab57300__"